<template>
  <div class="ui large modal" ref="modal">
    <div class="header">Transações</div>
    <div class="scrolling content">
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <table class="ui striped table">
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Data</th>
                  <th>Valor</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(transaction, index) in transactions" :key="index">
                  <td>
                    {{ transaction.id }}
                  </td>
                  <td>
                    {{ (transaction.date_updated || transaction.created_at) | datetime }}
                  </td>
                  <td>{{ (transaction.amount / 100) | money }}</td>
                  <td>{{ getStatus(transaction.status) || transaction.status }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/resources/Api';
const STATUS_MAP = {
  processing: 'Processando',
  authorized: 'Autorizado - Cliente possui saldo',
  paid: 'Pago',
  refunded: 'Estornado',
  waiting_payment: 'Aguardando Pagamento',
  pending_refund: 'Aguardando confirmação de estorno',
  refused: 'Recusado',
  chargedback: 'Transação sofreu chargeback',
  analyzing: 'Transação encaminhada para a análise manual.',
  pending_review: 'Transação pendente de revisão manual',
  failed: 'Falhou',
  canceled: 'Cancelado'
};

export default {
  data() {
    return {
      loading: false,
      transactions: []
    };
  },

  methods: {
    getStatus(status) {
      return STATUS_MAP[status];
    },

    open(externalID) {
      this.externalID = externalID;
      window.$(this.$refs.modal).modal('show');
      this.search();
    },

    search() {
      this.loading = true;

      Api.users
        .transactions(this.externalID)
        .then(response => {
          this.transactions = response.data.transactions;
        })
        .catch(error => {
          this.$toast.show('Erro ao carregar transações', 'error');
          this.loading = false;
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    hide() {
      window.$(this.$refs.modal).modal('hide');
    }
  }
};
</script>
